import BasePresenter from "../../redare/presenter/BasePresenter";
import * as DictionaryHttp from "../http/DictionaryHttp";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

export default class DictionaryPresenter extends BasePresenter {

    /**
     * @param body: {platform, parentCode, parentId, status}
     * @param query: {}
     * @returns Promise
     */
    findDictionaryList(body, query, success, fails) {

        if (this._onBeforeFindDictionaryList) {
            let data = this._onBeforeFindDictionaryList(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        DictionaryHttp.findDictionaryList(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindDictionaryListSuccess) {
                    result = this._onBeforeFindDictionaryListSuccess(result, {body, query});
                }

                if (this.view && this.view._onFindDictionaryListSuccess) {
                    this.view._onFindDictionaryListSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {platform, parentCode, parentId, status}
     * @param query: {}
     * @returns Promise
     */
    findTreeDictionaryList(body, query, success, fails) {

        if (this._onBeforeFindTreeDictionaryList) {
            let data = this._onBeforeFindTreeDictionaryList(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        DictionaryHttp.findTreeDictionaryList(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindTreeDictionaryListSuccess) {
                    result = this._onBeforeFindTreeDictionaryListSuccess(result, {body, query});
                }

                if (this.view && this.view._onFindTreeDictionaryListSuccess) {
                    this.view._onFindTreeDictionaryListSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {dicName, dicCode, dicValue, des, extArg, platform, parentId, parentCode, sort, dicName, dicCode, dicValue, des, extArg, platform, parentId, parentCode, sort}
     * @param query: {}
     * @returns Promise
     */
    addDictionary(body, query, success, fails) {

        if (this._onBeforeAddDictionary) {
            let data = this._onBeforeAddDictionary(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        DictionaryHttp.addDictionary(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeAddDictionarySuccess) {
                    result = this._onBeforeAddDictionarySuccess(result, {body, query});
                }

                if (this.view && this.view._onAddDictionarySuccess) {
                    this.view._onAddDictionarySuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {id, dicCode, dicName, dicValue, des, extArg, platform, sort}
     * @param query: {}
     * @returns Promise
     */
    editDictionary(body, query, success, fails) {

        if (this._onBeforeEditDictionary) {
            let data = this._onBeforeEditDictionary(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        DictionaryHttp.editDictionary(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeEditDictionarySuccess) {
                    result = this._onBeforeEditDictionarySuccess(result, {body, query});
                }

                if (this.view && this.view._onEditDictionarySuccess) {
                    this.view._onEditDictionarySuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {id, platform}
     * @param query: {}
     * @returns Promise
     */
    deleteDictionary(body, query, success, fails) {

        if (this._onBeforeDeleteDictionary) {
            let data = this._onBeforeDeleteDictionary(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        DictionaryHttp.deleteDictionary(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeDeleteDictionarySuccess) {
                    result = this._onBeforeDeleteDictionarySuccess(result, {body, query});
                }

                if (this.view && this.view._onDeleteDictionarySuccess) {
                    this.view._onDeleteDictionarySuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {id, platform, dicCode, parentId}
     * @param query: {}
     * @returns Promise
     */
    getDictionary(body, query, success, fails) {

        if (this._onBeforeGetDictionary) {
            let data = this._onBeforeGetDictionary(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        DictionaryHttp.getDictionary(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeGetDictionarySuccess) {
                    result = this._onBeforeGetDictionarySuccess(result, {body, query});
                }

                if (this.view && this.view._onGetDictionarySuccess) {
                    this.view._onGetDictionarySuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {id, status, platform}
     * @param query: {}
     * @returns Promise
     */
    changeDictionaryStatus(body, query, success, fails) {

        if (this._onBeforeChangeDictionaryStatus) {
            let data = this._onBeforeChangeDictionaryStatus(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        DictionaryHttp.changeDictionaryStatus(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeChangeDictionaryStatusSuccess) {
                    result = this._onBeforeChangeDictionaryStatusSuccess(result, {body, query});
                }

                if (this.view && this.view._onChangeDictionaryStatusSuccess) {
                    this.view._onChangeDictionaryStatusSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {dragId, hoverId}
     * @param query: {}
     * @returns Promise
     */
    sortDictionaryStatus(body, query, success, fails) {

        if (this._onBeforeSortDictionaryStatus) {
            let data = this._onBeforeSortDictionaryStatus(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        DictionaryHttp.sortDictionaryStatus(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeSortDictionaryStatusSuccess) {
                    result = this._onBeforeSortDictionaryStatusSuccess(result, {body, query});
                }

                if (this.view && this.view._onSortDictionaryStatusSuccess) {
                    this.view._onSortDictionaryStatusSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

}